const Config = {
  dataPickerMinDate: process.env.REACT_APP_DATA_PICKER_MIN_DATE || '',
  authURL: process.env.REACT_APP_AUTH_URL || '',
  backendUrl: process.env.REACT_APP_BACKEND_URL || '',
  appName: process.env.REACT_APP_NAME || '',
  numberOfFiles: 1,
};

export default Object.freeze(Config);
